import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { CoverImageRaw } from "./CoverImageRaw";
import type { CoverImageInterface } from "./types";

export const Offer = ({
  paywall,
  coverImageClassName,
  eventImageClassName,
}: CoverImageInterface) => (
  <CoverImageRaw
    paywall={paywall}
    coverImageClassName={classNames(
      "max-h-[281px] rounded-t-xl md:rounded-xl",
      coverImageClassName,
    )}
    eventImageClassName={eventImageClassName}
  />
);
